import { DateHelper, DateFormat } from '@utils/DateHelper';

import type { Nullable } from 'chaika-common-types';

import { AbstractField } from './AbstractField';

export class DateField extends AbstractField<Nullable<string>, Nullable<string>> {
    public getPreview(): string {
        let preview = '';

        try {
            preview = this.fieldValue
                ? DateHelper.format(new Date(this.fieldValue), DateFormat.DateWithDotSeparator)
                : '';
        } catch (e: any) {
            console.error('fieldName:', this.fieldName);
            console.error('fieldValue:', this.fieldValue);
            console.error(e);
        }
        return preview;
    }

    public makeUpdateParams(): Nullable<string> {
        return this.fieldValue;
    }

    protected setDefaultValueValue(): void {
        this.defaultNullValue = null;
    }

    protected setFieldValue(value: string): void {
        this.fieldValue = value;
    }
}
